import(/* webpackMode: "eager" */ "/builds/aleksundshantu/deepl-unmute-frontend/apps/template-standard/src/app/global-error.tsx");
